<mat-icon aria-hidden="false" class="critical">dangerous</mat-icon>
